(function() { window.GUID_a31e52de_7152_4e29_8061_c97ed422cf57 = { getGuid: function() { return "a31e52de-7152-4e29-8061-c97ed422cf57"; } }; })();
var CS;
(function (CS) {
    let Highlighted;
    (function (Highlighted) {
        Highlighted[Highlighted["PersonaWall"] = 0] = "PersonaWall";
        Highlighted[Highlighted["StatsWall"] = 1] = "StatsWall";
        Highlighted[Highlighted["EventWall"] = 2] = "EventWall";
        Highlighted[Highlighted["DivisionWall"] = 3] = "DivisionWall";
        Highlighted[Highlighted["MatchesWall"] = 4] = "MatchesWall";
        Highlighted[Highlighted["OpponentsWall"] = 5] = "OpponentsWall";
        Highlighted[Highlighted["Events"] = 6] = "Events";
        Highlighted[Highlighted["Leagues"] = 7] = "Leagues";
        Highlighted[Highlighted["LeaguesAndTournaments"] = 8] = "LeaguesAndTournaments";
        Highlighted[Highlighted["Tournaments"] = 9] = "Tournaments";
        Highlighted[Highlighted["MyEventsUnidentified"] = 10] = "MyEventsUnidentified";
        Highlighted[Highlighted["MyEventsLinked"] = 11] = "MyEventsLinked";
        Highlighted[Highlighted["MyEventsNotLinked"] = 12] = "MyEventsNotLinked";
        Highlighted[Highlighted["MyPins"] = 13] = "MyPins";
        Highlighted[Highlighted["MyMessages"] = 14] = "MyMessages";
        Highlighted[Highlighted["Schedules"] = 15] = "Schedules";
        Highlighted[Highlighted["Stats"] = 16] = "Stats";
        Highlighted[Highlighted["Brackets"] = 17] = "Brackets";
        Highlighted[Highlighted["MyMessagesAll"] = 18] = "MyMessagesAll";
        Highlighted[Highlighted["MyMessagesRead"] = 19] = "MyMessagesRead";
        Highlighted[Highlighted["MyMessagesUnread"] = 20] = "MyMessagesUnread";
        Highlighted[Highlighted["MyMessagesAboutMe"] = 21] = "MyMessagesAboutMe";
        Highlighted[Highlighted["MyMessagesAboutFollowed"] = 22] = "MyMessagesAboutFollowed";
        Highlighted[Highlighted["SettingsFollowers"] = 23] = "SettingsFollowers";
        Highlighted[Highlighted["SettingsBlockedUsers"] = 24] = "SettingsBlockedUsers";
        Highlighted[Highlighted["SettingsFollowedPlayers"] = 25] = "SettingsFollowedPlayers";
        Highlighted[Highlighted["SettingsLastSearches"] = 26] = "SettingsLastSearches";
        Highlighted[Highlighted["SettingsFavorites"] = 27] = "SettingsFavorites";
        Highlighted[Highlighted["SchedulesList"] = 28] = "SchedulesList";
        Highlighted[Highlighted["SchedulesTable"] = 29] = "SchedulesTable";
        Highlighted[Highlighted["StatGraph"] = 30] = "StatGraph";
        Highlighted[Highlighted["Summary"] = 31] = "Summary";
        Highlighted[Highlighted["MatchHistory"] = 32] = "MatchHistory";
        Highlighted[Highlighted["StatGrids"] = 33] = "StatGrids";
        Highlighted[Highlighted["WeeklyStatGrids"] = 34] = "WeeklyStatGrids";
        Highlighted[Highlighted["Compare"] = 35] = "Compare";
        Highlighted[Highlighted["BestImprovements"] = 36] = "BestImprovements";
        Highlighted[Highlighted["MainMenu"] = 37] = "MainMenu";
        Highlighted[Highlighted["Settings"] = 38] = "Settings";
        Highlighted[Highlighted["Leaderboard"] = 39] = "Leaderboard";
        Highlighted[Highlighted["Home"] = 40] = "Home";
        Highlighted[Highlighted["MainSearch"] = 41] = "MainSearch";
        Highlighted[Highlighted["SurfacesWall"] = 42] = "SurfacesWall";
        Highlighted[Highlighted["NotificationsWall"] = 43] = "NotificationsWall";
    })(Highlighted = CS.Highlighted || (CS.Highlighted = {}));
})(CS || (CS = {}));

//# sourceMappingURL=Highlighted.pre.js.map
